"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireWildcard(require("./Button.style"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Button(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["text", "icon", "iconPosition", "children"]);

  return _react["default"].createElement(_Button["default"], props, icon ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Button.StyledIcon, {
    text: text,
    iconPosition: iconPosition
  }, icon), text) : text, children);
}

Button.propTypes = {
  disabled: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].any,
  text: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  primary: _propTypes["default"].bool,
  size: _propTypes["default"].string,
  iconPosition: _propTypes["default"].string,
  secondary: _propTypes["default"].bool,
  tertiary: _propTypes["default"].bool,
  icon: _propTypes["default"].element
};
Button.defaultProps = {
  disabled: false,
  size: 'default',
  primary: true,
  iconPosition: 'left'
};
var _default = Button;
exports["default"] = _default;